import styled from "styled-components";

export const UploadFileStyleDiv = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 30px;


    .column-step1 {
        position: relative;
        background-color: #ddd;
        padding: 20px;
        width: 25%;
        text-align: center;
        border-radius: 8px;
        height: 75px;

    }

    .column-step2 {
        position: relative;
        background-color: #ddd;
        padding: 20px;
        width: 75%;
        text-align: center;
        border-radius: 8px;
        height: 75px;
    }

    .step-number {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-weight: bold;
        background-color: white;
        color: black;
        border-radius: 50%;
        text-align: center;
        border: 1px solid #ccc;
        user-select: none;
    }

`;